import {UAParser} from 'ua-parser-js';

const getBrowser = () => {
    const uaParser = new UAParser();

    return uaParser.getBrowser();
};

const getBrowserName = () => {
    return getBrowser().name;
};

const getDeviceType = () => {
    const uaParser = new UAParser();
    const deviceType = uaParser.getDevice().type;

    // ua-parser-js can only detect non-desktop devices.
    // For desktops (and probably any unknown device), the device type is set to undefined.
    if (!deviceType) return 'desktop';

    return deviceType;
};

const getOS = () => {
    const uaParser = new UAParser();

    return uaParser.getOS();
};

const getOSName = () => {
    const {name} = getOS();

    return name?.toLowerCase();
};

const getOSShortName = () => {
    const name = getOSName();

    return name.substr(0, 3);
};

const getBrowserVersion = () => {
    return getBrowser().version;
};

const getOSVersion = () => {
    return getOS().version;
};

const parseMajorVersion = (version) => {
    if (!version) return null;

    const parts = version.split('.');
    const majorVersion = parseInt(parts[0], 10);

    return isNaN(majorVersion) ? null : majorVersion;
};

const parseMinorVersion = (version) => {
    if (!version) return null;

    const parts = version.split('.');
    const minorVersion = parseInt(parts[1] || '0', 10);

    return isNaN(minorVersion) ? null : minorVersion;
};

const isIos = () => {
    const name = getOSName();

    return name === 'ios';
};

const isMac = () => {
    const name = getOSName();

    return name === 'macos' || name === 'mac os';
};

const isWindows = () => {
    const name = getOSName();

    return name === 'windows';
};

const isAndroid = () => {
    const name = getOSName();

    return name === 'android';
};

const isMobile = () => {
    const deviceType = getDeviceType();

    return deviceType === 'mobile';
};

const isDesktop = () => {
    const deviceType = getDeviceType();

    return deviceType === 'desktop';
};

const isTablet = () => {
    const deviceType = getDeviceType();

    return deviceType === 'tablet';
};

export default {
    getBrowserName,
    getDeviceType,
    getOS,
    getOSName,
    getOSShortName,
    getBrowserVersion,
    getOSVersion,
    parseMajorVersion,
    parseMinorVersion,
    isIos,
    isMobile,
    isTablet,
    isDesktop,
    isMac,
    isWindows,
    isAndroid,
};
